import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import AddProspect from "./components/AddProspect";
import toastr from "../../utils/toast";
import { MaterialReactTable } from "material-react-table";
import AddContacts from "./components/AddContacts";
import MeetingForm from "./components/MeetingForm";
import axios from "axios";
import CloseProspect from "./components/CloseProspect";
import Select from "react-select";
import ExistingClient from "./components/ExistingClient";
import PipelineCompanyNotesModal from "./components/PipelineCompanyNotesModal";
import DroppedStatus from "./components/DroppedStatus";
import PrepWithAIModal from "./components/PrepWithAIModal";
import useSmartBack from "../../hooks/useSmartBack";

function Pipeline() {
  const handleBack = useSmartBack("/lead_dashboard/view");
  const [addProspect, setAddProspect] = useState(false);
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [pipelinedCompanies, setPipelinedCompanies] = useState([]);
  const [companyInfoId, setCompanyInfoId] = useState(null);
  const [ContactsAddForm, setContactsAddForm] = useState(false);
  const [MeetingAddForm, setMeetingAddForm] = useState(false);
  const [countries, setCountries] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [users, setUsers] = useState([]);
  const [ClosePropectModal, setClosePropectModal] = useState(false);
  const [currencies, setCurrencies] = useState([]);

  const user = JSON.parse(localStorage.getItem("user"));

  const pipileine_data = useRef(false);

  const [ShowExistingClient, setShowExistingClient] = useState(false);
  const [ExistingClientId, setExistingClientId] = useState(null);

  const [showNotesModal, setShowNotesModal] = useState(false);
  const [ShowDroppedModal, setShowDroppedModal] = useState(false);
  const [showPrepModal, setShowPrepModal] = useState(false);

  const navigate = useNavigate();

  async function getPipelinedCompanies() {
    setGlobalLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/companyinfo/pipelined_companies`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await response.json();
      setPipelinedCompanies(data.pipelined_companies || []);
      console.log(data.pipelined_companies);
    } catch (error) {
      toastr.error("Error fetching pipelined companies");
    } finally {
      setGlobalLoading(false);
    }
  }

  async function getDropdownList() {
    try {
      const [country, status, user] = await Promise.all([
        axios.get(`${API_BASE_URL}/common_controller/get_countries_list`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
        axios.get(`${API_BASE_URL}/common_controller/get_pipeline_status`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
        axios.get(`${API_BASE_URL}/common_controller/get_active_users`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
      ]);
      setCountries(country.data.options);
      setStatuses(status.data);
      setUsers(user.data);
    } catch (error) {
      console.log(error);
    }
  }

  async function getAllCurrencies() {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/companyinfo/get_all_currencies`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log(response.data.currencies);
      setCurrencies(response.data.currencies);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getDropdownList();
    getAllCurrencies();
    if (pipileine_data.current) return;
    pipileine_data.current = true;
    getPipelinedCompanies();
  }, [token]);

  const getEditProps =
    (field) =>
    ({ cell, table }) => ({
      select: true,
      onChange: async (e) => {
        const value = e.target.value;
        const row = cell.row.original;

        console.log(e);

        if (row[field] === value) {
          table.setEditingCell(null);
          return;
        }

        try {
          if (field === "pipeline_status" && value === "Active (Converted)") {
            setCompanyInfoId(row.id);
            setClosePropectModal(true);
            return;
          } else if (field === "pipeline_status" && value === "Dropped") {
            setCompanyInfoId(row.id);
            setShowDroppedModal(true);
            return;
          }

          const payload = {
            id: row.id,
            [field]: value,
          };

          await axios.post(
            `${API_BASE_URL}/companyinfo/update_fields`,
            payload,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );

          let column_name = "";

          switch (field) {
            case "bd_region":
              column_name = "Region";
              break;
            case "country_name":
              column_name = "Country";
              break;
            case "pipeline_status":
              column_name = "Status";
              break;
            case "user_name":
              column_name = "Assigned To";
              break;
            default:
              break;
          }

          toastr.success(`${column_name} updated successfully`);

          let extraUpdate = {};

          if (field === "pipeline_status") {
            const selected = statuses.find((s) => s.name === value);

            extraUpdate.status_color = selected?.color || "";
          }

          setPipelinedCompanies((prev) =>
            prev.map((item) =>
              item.id === row.id
                ? { ...item, [field]: value, ...extraUpdate }
                : item,
            ),
          );

          // close edit mode
          table.setEditingCell(null);
        } catch (error) {
          console.log(error);
          toastr.error("Error updating field");
        }
      },
    });

  const getTextareaEditProps =
    (field) =>
    ({ cell, table }) => {
      let isSaving = false;

      const handleSave = async (value) => {
        if (isSaving) return;

        isSaving = true;

        await saveField(value, field, cell, table);

        setTimeout(() => {
          isSaving = false;
        }, 100);
      };

      return {
        multiline: field === "possible_searches",
        rows: field === "possible_searches" ? 4 : 1,

        type: field === "relationship" ? "number" : "text",

        inputProps:
          field === "relationship"
            ? {
                min: 1,
                max: 10,
              }
            : {},

        onBlur: async (e) => {
          await handleSave(e.target.value);
        },

        onKeyDown: async (e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            e.target.blur();
          }
        },
      };
    };

  const saveField = async (value, field, cell, table) => {
    const row = cell.row.original;

    if (row[field] === value) {
      table.setEditingCell(null);
      return;
    }

    try {
      const payload = {
        id: row.id,
        [field]: value,
      };

      await axios.post(`${API_BASE_URL}/companyinfo/update_fields`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setPipelinedCompanies((prev) =>
        prev.map((item) =>
          item.id === row.id ? { ...item, [field]: value } : item,
        ),
      );

      toastr.success("Updated successfully");

      table.setEditingCell(null);
    } catch (error) {
      console.log(error);
      toastr.error("Error updating field");
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "company_id",
        header: "Actions",
        size: 150,
        enableEditing: false,
        Cell: ({ cell }) => {
          const contacts_number = cell.row.original.total_contacts;
          const status = cell.row.original.pipeline_status;
          const meeting = cell.row.original?.next_meeting?.[0]?.meeting_date;
          return (
            <div>
              <button
                onClick={() => {
                  const id = cell.row.original.id;
                  setCompanyInfoId(id);
                  setContactsAddForm(true);
                }}
                className="btn btn-outline-primary rounded-pill fs-10 position-relative mb-1"
                title="Add Contacts"
              >
                <i className="fa-solid fa-user-group"></i>
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                  style={{ fontSize: "10px" }}
                >
                  {contacts_number ?? 0}
                </span>
              </button>

              <button
                onClick={() => {
                  const id = cell.row.original.id;
                  setCompanyInfoId(id);
                  setMeetingAddForm(true);
                }}
                className="btn btn-outline-secondary rounded-pill ms-2 fs-10"
                title="Set Meeting"
              >
                <i className="fa-solid fa-calendar-plus"></i>
              </button>

              <button
                onClick={() => {
                  setCompanyInfoId(cell.row.original.id);
                  setShowNotesModal(true);
                }}
                className="btn btn-outline-info rounded-pill fs-10 position-relative mb-1"
                title="Notes"
              >
                <i className="fa-solid fa-notes-medical"></i>

                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                  style={{ fontSize: "10px" }}
                >
                  {cell.row.original.total_notes ?? 0}
                </span>
              </button>
              <button
                onClick={() => {
                  if (meeting) {
                    setCompanyInfoId(cell.row.original.id);
                    setShowPrepModal(true);
                  } else {
                    toastr.error("No Upcoming Meeting Scheduled");
                  }
                }}
                className="btn btn-outline-danger rounded-pill ms-2 fs-10 position-relative"
                title="Prep With AI"
              >
                <i className="fa-solid fa-wand-magic-sparkles"></i>
              </button>
            </div>
          );
        },
      },
      {
        accessorKey: "companyinfo_name",
        header: "Company",
        size: 150,
        enableEditing: false,
        Cell: ({ cell }) => {
          const id = cell.row.original.id;
          const company_id = cell.row.original.company_id;
          return (
            <div>
              {company_id ? (
                <>
                  <Link to={`/client/view/${company_id}`}>
                    {cell.getValue()}
                  </Link>
                  <Link
                    target="_blank"
                    title="View CompanyInfo Page"
                    className="ms-2"
                    to={`/companyinfo/view/${id}`}
                  >
                    <i className="fa-solid fa-link"></i>
                  </Link>
                </>
              ) : (
                <Link to={`/companyinfo/view/${id}`}>
                  {cell.getValue()}
                </Link>
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "industrymaster",
        header: "Industries",
        size: 120,
        enableEditing: false,
        Cell: ({ cell }) => {
          const industries = cell.getValue();
          return (
            <div>
              <span className="badge rounded-pill bg-outline-dark text-dark">
                {industries}
              </span>
            </div>
          );
        },
      },
      {
        accessorKey: "bd_region",
        header: "BD Region",
        size: 150,
        editVariant: "select",
        enableEditing: (row) => row.original.created_by === user.id,
        editSelectOptions: [
          { value: "India", label: "India" },
          { value: "International", label: "International" },
        ],
        muiEditTextFieldProps: getEditProps("bd_region"),
      },
      {
        accessorKey: "country_name",
        header: "Country",
        size: 120,
        enableEditing: (row) => row.original.created_by === user.id,
        editSelectOptions:
          countries.map((item) => ({
            value: item.label,
            label: item.label,
          })) || [],
        muiEditTextFieldProps: getEditProps("country_name"),
      },
      {
        accessorKey: "pipeline_status",
        header: "Status",
        size: 150,
        enableEditing: (row) =>
          row.original.pipeline_status !== "Active (Converted)" &&
          row.original.pipeline_status !== "Existing Client",
        Cell: ({ cell }) => {
          const status = cell.getValue();
          const status_color = cell.row.original.status_color;
          const dropped_status_notes = cell.row.original.dropped_status_notes;
          return (
            <div>
              <span className={`badge rounded-pill ${status_color}`}>
                {status}
              </span>
              {dropped_status_notes !== "" && dropped_status_notes !== null && (
                <span className="ms-2">
                  <i
                    title={dropped_status_notes}
                    className="fa-solid fa-circle-info"
                  ></i>
                </span>
              )}
            </div>
          );
        },
        editSelectOptions:
          statuses.map((item) => ({
            value: item.name,
            label: item.name,
          })) || [],
        muiEditTextFieldProps: getEditProps("pipeline_status"),
      },
      {
        accessorKey: "user_name",
        header: "Assigned To",
        size: 150,
        enableEditing: (row) =>
          row.original.pipeline_status !== "Active (Converted)" &&
          row.original.created_by === user.id &&
          row.original.pipeline_status !== "Existing Client",
        editSelectOptions:
          users.map((item) => ({
            value: item.firstname + " " + item.lastname,
            label: item.firstname + " " + item.lastname,
          })) || [],
        muiEditTextFieldProps: getEditProps("user_name"),
      },
      {
        accessorKey: "last_meeting",
        header: "Last Meeting",
        size: 100,
        enableEditing: false,
        Cell: ({ cell }) => {
          const meeting = cell.row.original?.last_meeting?.[0]?.meeting_date;
          const candidate_name =
            cell.row.original?.last_meeting?.[0]?.candidate_name;
          if (meeting) {
            return (
              <>
                <span>{new Date(meeting).toLocaleDateString("en-CA")}</span>
                <br />
                <span className="fs-12">with {candidate_name}</span>
              </>
            );
          }
        },
      },
      {
        accessorKey: "next_meeting",
        header: "Next Meeting",
        size: 100,
        enableEditing: false,
        Cell: ({ cell }) => {
          const meeting = cell.row.original?.next_meeting?.[0]?.meeting_date;
          const candidate_name =
            cell.row.original?.next_meeting?.[0]?.candidate_name;
          if (meeting) {
            return (
              <>
                <span>
                  <i className="fa-regular fa-calendar text-primary me-sm-1"></i>
                  {new Date(meeting).toLocaleDateString("en-CA")}
                </span>
                <br />
                <span className="fs-12">with {candidate_name}</span>
              </>
            );
          }
        },
      },
      {
        accessorKey: "upcoming_meeting",
        header: "Reminder",
        size: 100,
        enableEditing: false,
        Cell: ({ cell }) => {
          const meeting = cell.row.original?.next_meeting?.[0]?.meeting_date;
          if (meeting) {
            return (
              <>
                <span>
                  <i className="fa-regular fa-calendar text-primary me-sm-1"></i>
                  {new Date(meeting).toLocaleDateString("en-CA")}
                </span>
              </>
            );
          }
        },
      },
      {
        accessorKey: "possible_searches",
        header: "Possible Searches",
        size: 100,
        editVariant: "textarea",
        enableEditing: (row) => row.original.created_by === user.id,
        Cell: ({ cell }) => {
          const searches = cell.row.original.possible_searches;
          return (
            <>
              {searches || (
                <span className="fs-10 text-muted">
                  {cell.row.original.pipeline_status !== "Active (Converted)"
                    ? "Add Possible Searches"
                    : "-"}
                </span>
              )}
            </>
          );
        },
        muiEditTextFieldProps: getTextareaEditProps("possible_searches"),
      },
      {
        accessorKey: "relationship",
        header: "Relationship Index",
        size: 100,
        enableEditing: (row) => row.original.created_by === user.id,
        Cell: ({ cell }) => {
          const relationship = cell.row.original.relationship;
          return (
            <>
              {relationship != 0 ? (
                <>
                  <span className="fw-bold">{relationship}</span> / 10
                </>
              ) : (
                <span className="fs-10 text-muted">
                  {cell.row.original.pipeline_status !== "Active (Converted)"
                    ? "Add Relationship"
                    : "-"}
                </span>
              )}
            </>
          );
        },
        muiEditTextFieldProps: getTextareaEditProps("relationship"),
      },
      {
        accessorKey: "revenue_impact",
        header: "Revenue Impact",
        size: 100,
        enableEditing: (row) => row.original.created_by === user.id,
        Cell: ({ cell }) => {
          const revenue = cell.row.original.revenue_impact;
          const currency = cell.row.original.revenue_currency_id;
          const symbol = cell.row.original.symbol;
          return (
            <>
              {revenue && currency ? (
                <span className="fw-bold">
                  {symbol} {revenue}
                </span>
              ) : (
                <span className="fs-10 text-muted">
                  {cell.row.original.pipeline_status !== "Active (Converted)"
                    ? "Add Revenue Impact"
                    : "-"}
                </span>
              )}
            </>
          );
        },

        Edit: ({ cell, row, table }) => {
          const [amount, setAmount] = useState(
            row.original.revenue_impact?.split(" ")[0] || "",
          );

          const [currency, setCurrency] = useState(
            row.original.revenue_currency_id || "",
          );

          const [unit, setUnit] = useState(
            row.original.revenue_impact?.split(" ")[1] || "",
          );

          const unitSelectRef = useRef(null);

          const rupeeHandler = [
            {
              label: "Crore",
              value: "Cr",
            },
            {
              label: "Lakh",
              value: "Lk",
            },
          ];

          const otherHandler = [
            {
              label: "Million",
              value: "Mn",
            },
            {
              label: "Thousand",
              value: "K",
            },
          ];

          const saveRevenue = async () => {
            if (!amount || !currency || !unit) return;

            try {
              await axios.post(
                `${API_BASE_URL}/companyinfo/update_fields`,
                {
                  id: row.original.id,
                  revenue_impact: amount + " " + unit,
                  revenue_currency_id: currency,
                },
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                },
              );

              const selectedCurrency = currencies.find(
                (c) => Number(c.id) === Number(currency),
              );

              setPipelinedCompanies((prev) =>
                prev.map((item) =>
                  item.id === row.original.id
                    ? {
                        ...item,
                        revenue_impact: amount + " " + unit,
                        revenue_currency_id: currency,
                        symbol: selectedCurrency?.symbol || "",
                      }
                    : item,
                ),
              );

              toastr.success("Revenue updated");

              table.setEditingCell(null);
            } catch (error) {
              console.log(error);
              toastr.error("Error updating revenue");
            }
          };

          return (
            <div
              className="d-flex gap-2 align-items-center"
              tabIndex={-1}
              onBlur={(e) => {
                if (!e.currentTarget.contains(e.relatedTarget)) {
                  if (!amount || !currency || !unit) {
                    table.setEditingCell(null);
                    return;
                  }

                  saveRevenue();
                }
              }}
            >
              <Select
                value={
                  [
                    {
                      value: "",
                      label: "Select",
                    },
                    ...currencies.map((item) => ({
                      value: item.id,
                      label: item.symbol,
                    })),
                  ].find((item) => item.value === currency) || null
                }
                onChange={(selected) => {
                  const newCurrency = selected?.value || "";

                  const oldIsRupee = Number(currency) === 1;
                  const newIsRupee = Number(newCurrency) === 1;

                  setCurrency(newCurrency);

                  // only reset + reopen if switching
                  // between INR <-> non-INR
                  if (oldIsRupee !== newIsRupee) {
                    setUnit("");

                    setTimeout(() => {
                      unitSelectRef.current?.focus();
                    }, 100);
                  }
                }}
                options={[
                  { value: "", label: "Select" },

                  ...currencies.map((item) => ({
                    value: item.id,
                    label: item.symbol,
                  })),
                ]}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                  container: (base) => ({
                    ...base,
                    minWidth: 40,
                  }),
                }}
              />

              <input
                type="text"
                className="form-control form-control-sm"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    saveRevenue();
                  }
                }}
                style={{
                  width: "80px",
                }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9.]/g, "");
                }}
                onKeyPress={(e) => {
                  if (!/^[0-9.]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />

              <Select
                ref={unitSelectRef}
                options={[
                  {
                    label: "Select",
                    value: "",
                  },
                  ...(Number(currency) === 1 ? rupeeHandler : otherHandler),
                ]}
                value={
                  [
                    {
                      value: "",
                      label: "Select",
                    },
                    ...(Number(currency) === 1 ? rupeeHandler : otherHandler),
                  ].find((item) => item.value === unit) || null
                }
                onChange={(selected) => {
                  setUnit(selected?.value || "");
                }}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                  container: (base) => ({
                    ...base,
                    minWidth: 100,
                  }),
                }}
              />
            </div>
          );
        },
      },
    ],
    [pipelinedCompanies],
  );

  const [filters, setFilters] = useState({
    company: "",
    statuses: [],
    users: [],
    industries: [],
    bd_regions: [],
  });

  const filteredData = useMemo(() => {
    return pipelinedCompanies?.filter((item) => {
      // Company search
      const matchCompany =
        !filters.company ||
        item.companyinfo_name
          ?.toLowerCase()
          .includes(filters.company.toLowerCase());

      // Status
      const matchStatus =
        filters.statuses.length === 0 ||
        filters.statuses.includes(item.pipeline_status);

      // Assigned To
      const matchUser =
        filters.users.length === 0 || filters.users.includes(item.user_name);

      // Industries
      const matchIndustry =
        filters.industries.length === 0 ||
        filters.industries.includes(item.industrymaster);

      // BD Region
      const matchRegion =
        filters.bd_regions.length === 0 ||
        filters.bd_regions.includes(item.bd_region);

      return (
        matchCompany && matchStatus && matchUser && matchIndustry && matchRegion
      );
    });
  }, [pipelinedCompanies, filters]);

  return (
    <>
      {ContactsAddForm && (
        <AddContacts
          onClose={() => {
            setContactsAddForm(false);
            getPipelinedCompanies();
          }}
          company_id={companyInfoId}
        />
      )}

      {MeetingAddForm && (
        <MeetingForm
          onClose={() => {
            setMeetingAddForm(false);
            getPipelinedCompanies();
          }}
          company_id={companyInfoId}
        />
      )}

      {ClosePropectModal && (
        <CloseProspect
          onClose={() => {
            setClosePropectModal(false);
            getPipelinedCompanies();
          }}
          company_id={companyInfoId}
        />
      )}

      {ShowExistingClient && (
        <ExistingClient
          onClose={() => {
            setShowExistingClient(false);
            getPipelinedCompanies();
          }}
          company_id={ExistingClientId}
        />
      )}

      {showNotesModal && (
        <PipelineCompanyNotesModal
          onClose={() => {
            setShowNotesModal(false);
            getPipelinedCompanies();
          }}
          companyInfoId={companyInfoId}
        />
      )}

      {ShowDroppedModal && (
        <DroppedStatus
          onClose={() => {
            setShowDroppedModal(false);
            getPipelinedCompanies();
          }}
          company_id={companyInfoId}
        />
      )}

      {showPrepModal && (
        <PrepWithAIModal
          companyinfoId={companyInfoId}
          onClose={() => setShowPrepModal(false)}
        />
      )}

      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">BD Pipeline</h2>
            <p className="fs-14">Track and manage prospective clients</p>
          </div>
          <div>
            {pipelinedCompanies?.length > 0 && (
              <button
                onClick={handleBack}
                className="btn btn-outline-secondary rounded-pill"
              >
                <i className="fa-solid fa-arrow-left"></i> Lead Dashboard
              </button>
            )}
            <button
              onClick={() => navigate("/lead_dashboard/searchUniverse")}
              className="btn btn-outline-secondary rounded-pill ms-2"
            >
              Target Universe
              <i className="fa-solid fa-arrow-right ms-2"></i>
            </button>
            <button
              onClick={() => setAddProspect(true)}
              className="btn btn-dark rounded-pill ms-2"
            >
              <i className="fa-solid fa-plus"></i> Add Prospect
            </button>
            {addProspect && (
              <AddProspect
                onClose={async (id) => {
                  setAddProspect(false);
                  getPipelinedCompanies();
                  if (id) {
                    setShowExistingClient(true);
                    setExistingClientId(id);
                  }
                }}
              />
            )}
          </div>
        </div>

        {pipelinedCompanies?.length > 0 && (
          <div className="row">
            <div className="col-md-12 col-lg-12 col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    {/* Company Search */}
                    <div className="col-md-3">
                      <label>Company</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search company..."
                        value={filters.company}
                        onChange={(e) =>
                          setFilters({ ...filters, company: e.target.value })
                        }
                      />
                    </div>

                    {/* Status Filter */}
                    <div className="col-md-3">
                      <label>Status</label>
                      <Select
                        isMulti
                        options={statuses.map((item) => ({
                          value: item.name,
                          label: item.name,
                        }))}
                        value={filters.statuses.map((s) => ({
                          value: s,
                          label: s,
                        }))}
                        onChange={(selected) =>
                          setFilters({
                            ...filters,
                            statuses: selected
                              ? selected.map((s) => s.value)
                              : [],
                          })
                        }
                        placeholder="Select Status"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>

                    {/* Assigned To */}
                    <div className="col-md-3">
                      <label>Assigned To</label>
                      <Select
                        isMulti
                        options={users.map((item) => ({
                          value: item.firstname + " " + item.lastname,
                          label: item.firstname + " " + item.lastname,
                        }))}
                        value={filters.users.map((u) => ({
                          value: u,
                          label: u,
                        }))}
                        onChange={(selected) =>
                          setFilters({
                            ...filters,
                            users: selected ? selected.map((u) => u.value) : [],
                          })
                        }
                        placeholder="Select User"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>

                    {/* BD Region */}
                    <div className="col-md-3">
                      <label>BD Region</label>
                      <Select
                        isMulti
                        options={[
                          { value: "India", label: "India" },
                          { value: "International", label: "International" },
                        ]}
                        value={filters.bd_regions.map((r) => ({
                          value: r,
                          label: r,
                        }))}
                        onChange={(selected) =>
                          setFilters({
                            ...filters,
                            bd_regions: selected
                              ? selected.map((r) => r.value)
                              : [],
                          })
                        }
                        placeholder="Select BD Region"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="row p-1">
          <MaterialReactTable
            columns={columns}
            data={filteredData || []}
            enableColumnFilters
            enableSorting
            enablePagination
            positionActionsColumn="last"
            enableEditing={true}
            editDisplayMode="cell"
            autoResetPageIndex={false}
            initialState={{
              pagination: {
                pageIndex: 0,
                pageSize: 50,
              },
            }}
            muiTableBodyCellProps={({ cell, table }) => {
              const isEditable = cell.column.columnDef.enableEditing;

              const canEdit =
                typeof isEditable === "function"
                  ? isEditable(cell.row)
                  : isEditable;

              return {
                title: canEdit ? "Double click to edit" : "",

                onDoubleClick: () => {
                  if (canEdit) {
                    table.setEditingCell(cell);
                  }
                },

                sx: {
                  cursor: canEdit ? "pointer" : "default",
                  "&:hover": canEdit
                    ? {
                        backgroundColor: "#f5f5f5",
                      }
                    : {},
                },
              };
            }}
          />
        </div>
      </div>
    </>
  );
}

export default Pipeline;
